export const abbreviateNumber = (value) => {
  let newValue = value;
  if (value >= 1000) {
    const suffixes = ["", "k", "m", "b", "t"];
    const suffixNum = Math.floor(`${value}`.length / 3);
    let shortValue = "";
    for (let precision = 2; precision >= 1; precision--) {
      shortValue = Number.parseFloat(
        (suffixNum !== 0 ? value / 1000 ** suffixNum : value).toPrecision(precision),
      );
      const dotLessShortValue = `${shortValue}`.replace(/[^a-zA-Z 0-9]+/g, "");
      if (dotLessShortValue.length <= 2) {
        break;
      }
    }
    if (shortValue % 1 !== 0) shortValue = shortValue.toFixed(1);
    newValue = shortValue + suffixes[suffixNum];
  }
  return newValue;
};

export const filterFeatures = (feature, firstArea, secondArea) => {
  if (firstArea.name === feature.properties.n) {
    feature.properties.c = "rgba(60, 241, 198, 0.5)";
    feature.properties.co = "#3cf1c6";
  } else if (secondArea?.name === feature.properties.n) {
    feature.properties.c = "rgba(255, 0, 128, 0.5)";
    feature.properties.co = "#FF0080";
  } else {
    feature.properties.c = "rgba(255, 0, 128, 0.1)";
    feature.properties.co = "#FF0080";
  }
  return feature;
};

export const validateEmail = (mail) => {
  if (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(mail)) {
    return true;
  }
  return false;
};

export const getZoom = (layer: "country" | "district" | "city" | "borough", maxZoom: boolean) => {
  switch (layer) {
    case "country":
      return maxZoom ? 5.25 : 0;
    case "district":
      return maxZoom ? 7 : 5.25;
    case "city":
      return maxZoom ? 9 : 7;
    case "borough":
      return maxZoom ? 22 : 9;
    default:
      return 0;
  }
};

export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export const createGeoJSONCircle = (
  center: [number, number],
  radiusInKm: number,
  points?: number,
) => {
  if (!points) points = 64;

  const coords = {
    latitude: center[1],
    longitude: center[0],
  };

  const km = radiusInKm;

  const ret = [];
  const distanceX = km / (111.32 * Math.cos((coords.latitude * Math.PI) / 180));
  const distanceY = km / 110.574;

  let theta;
  let x;
  let y;
  for (let i = 0; i < points; i++) {
    theta = (i / points) * (2 * Math.PI);
    x = distanceX * Math.cos(theta);
    y = distanceY * Math.sin(theta);

    ret.push([coords.longitude + x, coords.latitude + y]);
  }
  ret.push(ret[0]);

  return {
    type: "FeatureCollection" as const,
    features: [
      {
        type: "Feature",
        properties: {},
        geometry: {
          type: "Polygon",
          coordinates: [ret],
        },
      },
    ],
  } satisfies GeoJSON.FeatureCollection<GeoJSON.Geometry>;
};
